import LogoIcon from '@/assets/svg/logo.svg?react';
import { HEADER_HEIGHT } from '@/constants/dimensions';
import { cn } from '@/lib/utils';

type Props = {
  className?: string;
  whiteLogo?: boolean;
  blackLogo?: boolean;
};

const Logo = ({ className, whiteLogo, blackLogo }: Props) => {
  const logoHeight = HEADER_HEIGHT;

  return (
    <div
      className={cn(
        'bg-logo-header z-1 flex items-center justify-center text-primary',
        whiteLogo && 'bg-none! text-white',
        blackLogo && 'bg-none! text-gray-900',
        className,
      )}
      style={{
        height: logoHeight,
        minHeight: logoHeight,
        maxHeight: logoHeight,
      }}
    >
      <LogoIcon />
    </div>
  );
};

export default Logo;
